import { useState } from "react";
import { Button, type ButtonVariant } from "./Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./Dialog";

export interface ConfirmDialogProps {
  title?: string;
  message?: React.ReactNode;
  onSubmit?: () => Promise<void>;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: React.ReactNode;
  cancelLabel?: React.ReactNode;
  confirmVariant?: ButtonVariant;
  cancelVariant?: ButtonVariant;
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
}

export const ConfirmDialog = ({
  title = "Confirm",
  message,
  onSubmit,
  onConfirm,
  onCancel,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = undefined,
  cancelVariant = "destructive",
  open,
  setOpen,
  className,
}: ConfirmDialogProps) => {
  const [loading, setLoading] = useState(false);

  if (typeof message === "string") {
    message = <p>{message}</p>;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={className}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="my-2">{message}</div>
        </DialogBody>
        <DialogFooter className="justify-between">
          <Button
            variant={cancelVariant}
            disabled={loading}
            onClick={() => {
              onCancel?.();
              setOpen(false);
            }}
          >
            {cancelLabel}
          </Button>
          <div className="flex-1" />
          <Button
            variant={confirmVariant}
            disabled={loading}
            onClick={async () => {
              if (onSubmit) {
                setLoading(true);
                await onSubmit();
                setLoading(false);
              }
              onConfirm?.();
              setOpen(false);
            }}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
